/**
 * RESIDENTIAL LANDSCAPING FEATURED PROJECT
 * Last updated: [Date will auto-update when edited]
 * 
 * Update this file to change the residential landscaping featured project.
 */

const residentialProject = {
  category: "residential",
  title: "Two neighboring new-build homes, one cohesive vision.",
  images: {
    topLeft: {
      top: "/images/projects/sageDemo.jpeg",
      bottom: "/images/projects/sageRock2A.jpg",
      topAlt: "Residential project before",
      bottomAlt: "Residential project site preparation"
    },
    bottomLeft: {
      top: "/images/projects/sageFinal.jpg",
      bottom: "/images/projects/sageRock1.jpg",
      topAlt: "Residential project in progress",
      bottomAlt: "Residential project completed"
    }
  },
  paragraphs: [
    "This pair of new builds gave our team the opportunity to design two distinct landscapes that feel connected through craftsmanship and detail.",
    
    "Each property includes a full installation complete with grading and seeding, natural stone retaining walls, paver driveways and walkways, heated surfaces, and custom plantings. Working side by side, our crews coordinated every phase with precision to maintain progress, consistency, and quality between both sites.",
    
    "The result is a pair of landscapes that complement each other while standing confidently on their own — a reflection of our commitment to collaboration, efficiency, and excellence in every season."
  ]
};

export default residentialProject;